/* joacă bună — motor PDP self-contained: variant picker + cart AJAX (/cart/add.js).
   Lean (~2KB), zero dependențe. Progressive: fără JS, formularul tot trimite (full reload). */
(function () {
  'use strict';

  class JBProduct extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form[data-product-form]');
      this.idInput = this.querySelector('input[name="id"]');
      this.priceEl = this.querySelector('[data-price]');
      this.atc = this.querySelector('[data-atc]');
      this.atcLabel = this.querySelector('[data-atc-label]');
      this.media = this.querySelector('[data-main-media] img');
      try {
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      } catch (e) { this.variants = []; }

      this.addEventListener('change', this.onOptionChange.bind(this));
      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';

      // galerie: thumbnail → imagine principală
      this.addEventListener('click', (e) => {
        const thumb = e.target.closest('[data-thumb]');
        if (!thumb || !this.media) return;
        this.media.src = thumb.dataset.src; this.media.srcset = '';
        this.querySelectorAll('[data-thumb]').forEach((t) => t.classList.toggle('is-active', t === thumb));
      });
    }

    selectedOptions() {
      return Array.from(this.querySelectorAll('[data-option-selector]:checked, select[data-option-selector]'))
        .map((el) => el.value);
    }

    onOptionChange() {
      const opts = this.selectedOptions();
      const variant = this.variants.find((v) =>
        v.options.length === opts.length && v.options.every((o, i) => o === opts[i]));
      if (!variant) { this.setUnavailable(); return; }

      if (this.idInput) this.idInput.value = variant.id;
      if (this.priceEl) this.priceEl.innerHTML = this.formatMoney(variant.price);
      this.toggleSale(variant);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (variant.featured_media && this.media) {
        const src = variant.featured_media.preview_image && variant.featured_media.preview_image.src;
        if (src) { this.media.src = src.replace(/(\.[a-z]+)(\?.*)?$/i, '$1') + '?width=1200'; this.media.srcset = ''; }
      }

      if (this.atc) {
        this.atc.disabled = !variant.available;
        if (this.atcLabel) this.atcLabel.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
      }
    }

    setUnavailable() {
      if (this.atc) { this.atc.disabled = true; if (this.atcLabel) this.atcLabel.textContent = this.dataset.unavailLabel || 'Indisponibil'; }
    }
    toggleSale(v) {
      const wrap = this.priceEl && this.priceEl.closest('.jb-price');
      if (!wrap) return;
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      wrap.classList.toggle('jb-price--on-sale', !!onSale);
    }

    formatMoney(cents) {
      const noDec = /no_decimals/.test(this.moneyFormat);
      const amount = (cents / 100).toLocaleString('ro-RO', { minimumFractionDigits: noDec ? 0 : 2, maximumFractionDigits: noDec ? 0 : 2 });
      // acoperă {{amount}}, {{amount_with_comma_separator}}, {{amount_no_decimals}} etc.
      if (/\{\{\s*amount/.test(this.moneyFormat)) return this.moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
      return amount + ' lei';
    }

    onSubmit(e) {
      if (!window.fetch) return; // fallback: submit normal
      e.preventDefault();
      if (this.atcBusy) return; // guard anti-double-submit — fără disabled vizual
      this.atcBusy = true;
      const data = new FormData(this.form);
      if (this.atc) this.atc.setAttribute('aria-busy', 'true');
      const prev = this.atcLabel ? this.atcLabel.textContent : '';
      if (this.atcLabel) this.atcLabel.textContent = '…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then((r) => r.json())
        .then((added) => {
          if (added.status) {
            // eșec real (stoc etc.) — reset, fără ștampilă
            this.atcBusy = false;
            if (this.atc) this.atc.removeAttribute('aria-busy');
            if (this.atcLabel) this.atcLabel.textContent = prev;
            return;
          }
          return fetch('/cart.js').then((r) => r.json()).then((cart) => {
            document.querySelectorAll('[data-cart-count]').forEach((el) => {
              el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
            });
            this.playAddedStamp(prev);
            this.dispatchEvent(new CustomEvent('jb:added', { bubbles: true, detail: { cart } }));
          });
        })
        .catch(() => { window.location.href = '/cart'; });
    }

    playAddedStamp(prevLabel) {
      if (typeof navigator.vibrate === 'function') navigator.vibrate(18);

      clearTimeout(this.atcResetTimeout);
      if (this.atc) this.atc.classList.add('jb-atc-added');
      if (this.atcLabel) this.atcLabel.textContent = this.dataset.addedLabel || 'Adăugat';

      this.atcResetTimeout = setTimeout(() => {
        if (this.atc) { this.atc.classList.remove('jb-atc-added'); this.atc.removeAttribute('aria-busy'); }
        if (this.atcLabel) this.atcLabel.textContent = prevLabel;
        this.atcBusy = false;
      }, 1500);
    }
  }
  customElements.define('jb-product', JBProduct);
})();